module.exports = __webpack_public_path__ + "media/images/pix/glin_qr_code-7a375a619828b238991fc8f7d9bf798f.png";